import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, ShieldAlert } from "lucide-react";
import {
  authClient,
  REDIRECT_URI,
  popPostLoginRedirect,
  saveTokens,
  takeChallenge,
} from "@/lib/auth-client";
import { Button } from "@/components/ui/Button";

export function AuthCallbackPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const code = params.get("code");
  const oauthError = params.get("error");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (oauthError) {
      setError(oauthError);
      return;
    }
    if (!code) {
      setError("missing_code");
      return;
    }
    const challenge = takeChallenge();
    if (!challenge) {
      setError("missing_challenge");
      return;
    }
    void (async () => {
      try {
        const exchanged = await authClient.exchange(
          code,
          REDIRECT_URI,
          challenge.verifier,
        );
        if (exchanged.err) {
          setError(String(exchanged.err));
          return;
        }
        saveTokens({
          access: exchanged.tokens.access,
          refresh: exchanged.tokens.refresh,
        });
        const target = popPostLoginRedirect() ?? "/";
        window.location.replace(target);
      } catch (e) {
        setError(e instanceof Error ? e.message : "unknown_error");
      }
    })();
  }, [code, oauthError]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6">
      <div className="w-full max-w-sm rounded-lg border border-slate-200 bg-white p-6 text-center shadow-sm">
        {error ? (
          <>
            <ShieldAlert className="h-8 w-8 text-red-600 mx-auto" />
            <p className="mt-3 text-sm text-slate-600">No pudimos completar el inicio de sesión.</p>
            <Button className="mt-4" onClick={() => navigate("/login?reason=error")}>
              Volver al login
            </Button>
          </>
        ) : (
          <>
            <Loader2 className="h-8 w-8 animate-spin text-brand-600 mx-auto" />
            <p className="mt-3 text-sm text-slate-600">Verificando sesión…</p>
          </>
        )}
      </div>
    </div>
  );
}